<template>
    <div class="corp-id">
        {{ $l10n.__("ID Compte Sellsy") }}&nbsp;-&nbsp;<span>{{ corpId }}</span>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapGetters } = createNamespacedHelpers("corp");

export default {
    computed: {
        ...mapGetters(["corpId"]),
    },
};
</script>
<style lang="scss" scoped>
    @import '~@sellsy/styleguide/src/_variables';

    .corp-id {
        align-items: center;
        background: $gray-05;
        border-radius: 4px;
        color: $gray-100;
        display: inline-flex;
        font-size: 14px;
        line-height: 20px;
        padding: 6px 8px;

        span {
            font-weight: 600;
        }
    }
</style>